import createService from 'shared/utils/createService.js';
import { PRODUCT_API_URL } from './productEnum.js';

export default createService(PRODUCT_API_URL, {
  extraMethods: {},
});
